import { useNavigate } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { Reveal, Counter } from "../components/common";
import { STATS, STEPS } from "../data/content";
import { Seo, breadcrumbs } from "../components/Seo";

const BG = "https://images.unsplash.com/photo-1515703944563-dbcfbf121b3d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920";

export default function BusinessFinance() {
  const navigate = useNavigate();
  return (
    <div data-testid="business-finance-page" className="pt-32">
      <Seo title="Business Finance" path="/business-finance" description="How DNA Finance arranges business funding: tell us your requirement, we compare 165+ UK lenders, you receive tailored options and we manage the process to drawdown." jsonLd={breadcrumbs([{ name: "Home", path: "/" }, { name: "Business Finance", path: "/business-finance" }])} />
      <section className="container-x mx-auto max-w-[1400px] py-16 grid lg:grid-cols-2 gap-16 items-center">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.3em] text-lime mb-4">Business Finance</p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter leading-[0.95]">Funding that moves at the speed of your business</h1>
          <p className="text-grey text-lg mt-6 leading-relaxed">DNA Finance is a UK commercial finance brokerage. We help established businesses and ambitious entrepreneurs access the funding they need, structured around their goals and explained without jargon.</p>
          <ul className="mt-8 space-y-3">
            {["Whole-of-market access to 165+ lenders", "Fast, informed decisions", "Dedicated relationship management", "AML-compliant, regulated process"].map((f) => (
              <li key={f} className="flex items-center gap-3"><Check className="w-5 h-5 text-lime" /><span>{f}</span></li>
            ))}
          </ul>
          <button onClick={() => navigate("/contact?src=business-finance")} data-testid="bf-get-funding-btn" className="mt-10 inline-flex items-center gap-2 bg-lime text-[#1A1A1A] font-bold px-8 py-4 hover:glow-lime transition-shadow">Get Funding <ArrowRight className="w-5 h-5" /></button>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="relative h-[440px] border border-[#808080]/30 overflow-hidden">
            <img src={BG} alt="" className="w-full h-full object-cover grayscale" />
            <div className="absolute inset-0 bg-black/40" />
          </div>
        </Reveal>
      </section>

      <section className="bg-black border-y border-[#808080]/20 py-16">
        <div className="container-x mx-auto max-w-[1400px] grid grid-cols-2 lg:grid-cols-4 gap-px bg-[#808080]/20 border border-[#808080]/20">
          {STATS.map((s) => (
            <div key={s.label} className="bg-black p-6 md:p-8 text-center">
              <div className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-black text-lime leading-none">{s.display ? s.display : <Counter to={s.value} suffix={s.suffix} />}</div>
              <p className="text-sm text-grey mt-2">{s.label}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="container-x mx-auto max-w-[1400px] py-24">
        <Reveal className="max-w-2xl mb-16"><h2 className="text-3xl sm:text-4xl font-black tracking-tight">How we work</h2></Reveal>
        <div className="grid md:grid-cols-4 gap-px bg-[#808080]/20 border border-[#808080]/20">
          {STEPS.map((step) => (
            <div key={step.n} className="bg-[#1A1A1A] p-8">
              <span className="text-5xl font-black text-lime/30">{step.n}</span>
              <h3 className="text-lg font-bold mt-4">{step.title}</h3>
              <p className="text-grey text-sm mt-3">{step.text}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
